(() => {
  if (customElements.get('saiyis-collection-browser')) return;
  class SaiyisCollectionBrowser extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panel = this.querySelector('.sc-filter-panel');
      this.sortPanel = this.querySelector('.sc-sort-panel');
      this.form = this.querySelector('.sc-filter-form');
      this.media = matchMedia('(min-width: 990px)');
      this.cache = new Map();
      this.serial = 0;
      this.draft = false;
      this.onViewport = () => {
        if (this.draft) this.cancelFilters();
        if (this.sortPanel.open) this.sortPanel.close();
        if (this.media.matches && !this.panel.open) this.panel.show();
        if (!this.media.matches && this.panel.open) this.panel.close();
        this.panel.setAttribute('role', this.media.matches ? 'region' : 'dialog');
        this.panel.setAttribute('aria-modal', this.media.matches ? 'false' : 'true');
        this.applyLayout(this.readLayout());
      };
      this.onHistory = () => this.load(new URL(location.href), {history: false});
      this.media.addEventListener('change', this.onViewport);
      window.addEventListener('popstate', this.onHistory);
      this.addEventListener('click', e => this.onClick(e));
      this.addEventListener('change', e => this.onChange(e));
      this.addEventListener('input', e => {
        if (e.target.matches('[data-option-search]')) this.limitOptions(e.target.closest('.sc-facet'));
        if (this.form.contains(e.target) && e.target.type === 'number') {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.load(this.formURL()), 450);
        }
      });
      this.addEventListener('submit', e => {
        if (e.target !== this.form) return;
        e.preventDefault();
        clearTimeout(this.timer);
        this.load(this.formURL(), {commitDraft: this.draft});
      });
      this.panel.addEventListener('cancel', e => { if (this.draft) { e.preventDefault(); this.cancelFilters(); } });
      this.sortPanel.addEventListener('click', e => { if (e.target === this.sortPanel) this.sortPanel.close(); });
      this.onViewport();
      this.limitAllOptions();
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.media?.removeEventListener('change', this.onViewport);
      window.removeEventListener('popstate', this.onHistory);
    }
    readLayout() {
      try { return localStorage.getItem(this.media.matches ? 'saiyis-collection-desktop' : 'saiyis-collection-mobile') || 'grid'; }
      catch { return 'grid'; }
    }
    applyLayout(layout) {
      this.dataset.layout = layout === 'list' ? 'list' : 'grid';
      this.querySelectorAll('[data-layout]').forEach(button => {
        if (button.tagName === 'BUTTON') button.setAttribute('aria-pressed', String(button.dataset.layout === this.dataset.layout));
      });
    }
    limitAllOptions() { this.querySelectorAll('.sc-facet').forEach(group => this.limitOptions(group)); }
    limitOptions(group) {
      const query = (group.querySelector('[data-option-search]')?.value || '').trim().toLocaleLowerCase();
      const organized = group.querySelector('[data-organized-options]');
      if (organized) {
        // Catalog quantity is primary; verified 90-day sales break quantity ties (2026-10-24).
        const salesOrder = {"brands": {"genie": 0, "skyjack": 1}, "parts": {"platform control box": 0, "joystick": 1, "ground control unit": 2, "connector": 3, "motor controller": 4}};
        const recent = salesOrder[organized.dataset.organizedOptions] || {};
        const established = organized.dataset.organizedOptions === 'brands' ? {genie: 0, jlg: 1, skyjack: 2, haulotte: 3, manitou: 4, snorkel: 5, airman: 6} : {};
        group.querySelectorAll('[data-options-list]').forEach(list => {
          const labels = [...list.querySelectorAll('.sc-option')];
          labels.sort((a, b) => Number(b.dataset.optionCount) - Number(a.dataset.optionCount)
            || (recent[a.dataset.optionKey] ?? 999) - (recent[b.dataset.optionKey] ?? 999)
            || (established[a.dataset.optionKey] ?? 999) - (established[b.dataset.optionKey] ?? 999)
            || a.dataset.optionLabel.localeCompare(b.dataset.optionLabel));
          labels.forEach(label => {
            list.append(label);
            label.hidden = Boolean(query) && !label.dataset.optionLabel.includes(query) && !label.dataset.optionKey.includes(query);
          });
        });
        organized.querySelectorAll('[data-options-bucket]').forEach(bucket => {
          const labels = [...bucket.querySelectorAll('.sc-option')];
          const matching = labels.filter(label => !label.hidden).length;
          bucket.hidden = matching === 0;
          bucket.querySelector('[data-bucket-count]').textContent = matching;
          if (query) {
            if (!bucket.hasAttribute('data-open-before-search')) bucket.dataset.openBeforeSearch = String(bucket.open);
            bucket.open = true;
          } else if (bucket.hasAttribute('data-open-before-search')) {
            bucket.open = bucket.dataset.openBeforeSearch === 'true';
            delete bucket.dataset.openBeforeSearch;
          }
        });
        return;
      }
      const expanded = group.querySelector('[data-more-options]')?.getAttribute('aria-expanded') === 'true';
      let index = 0;
      group.querySelectorAll('.sc-option').forEach(label => {
        const input = label.querySelector('input');
        const matches = !query || label.dataset.optionLabel.includes(query);
        const visible = matches && (query || expanded || index < 6 || input.checked);
        label.hidden = !visible;
        if (matches) index++;
      });
      const more = group.querySelector('[data-more-options]');
      if (more) more.hidden = Boolean(query) || index <= 6 || expanded;
    }
    formURL() {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      [...url.searchParams.keys()].filter(key => key.startsWith('filter.')).forEach(key => url.searchParams.delete(key));
      const values = new FormData(this.form);
      for (const [key, value] of values) {
        if (!String(value).trim()) continue;
        if (key.startsWith('filter.')) url.searchParams.append(key, value);
        else url.searchParams.set(key, value);
      }
      url.searchParams.set('sort_by', this.querySelector('[data-sort-select]').value);
      return url;
    }
    onClick(e) {
      const button = e.target.closest('button');
      if (button?.hasAttribute('data-open-filters')) {
        this.draft = true;
        this.savedFilters = this.querySelector('[data-filters-body]').innerHTML;
        this.savedApply = this.querySelector('[data-apply]').textContent;
        this.panel.close();
        this.panel.showModal();
        button.setAttribute('aria-expanded', 'true');
      }
      if (button?.hasAttribute('data-close-filters')) this.cancelFilters();
      if (button?.hasAttribute('data-open-sort')) this.sortPanel.showModal();
      if (button?.hasAttribute('data-close-sort')) this.sortPanel.close();
      if (button?.dataset.layout) {
        this.applyLayout(button.dataset.layout);
        try { localStorage.setItem(this.media.matches ? 'saiyis-collection-desktop' : 'saiyis-collection-mobile', this.dataset.layout); } catch {}
      }
      if (button?.hasAttribute('data-more-options')) {
        button.setAttribute('aria-expanded', 'true');
        this.limitOptions(button.closest('.sc-facet'));
      }
      if (button?.hasAttribute('data-clear')) {
        clearTimeout(this.timer);
        const url = new URL(location.href);
        [...url.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page').forEach(key => url.searchParams.delete(key));
        this.load(url, {skipValidation: true});
      }
      if (button?.hasAttribute('data-retry') && this.retryURL) this.load(new URL(this.retryURL), this.retryOptions);
      const link = e.target.closest('a[data-remove], .sc-pagination a[href]');
      if (link && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
        e.preventDefault();
        const url = new URL(link.href);
        if (url.origin === location.origin) this.load(url, {skipValidation: true});
      }
    }
    onChange(e) {
      if (e.target.matches('[data-sort-select], [data-sort-choice]')) {
        this.querySelector('[data-sort-select]').value = e.target.value;
        this.form.elements.sort_by.value = e.target.value;
        if (this.sortPanel.open) this.sortPanel.close();
        const url = new URL(location.href);
        url.searchParams.set('sort_by', e.target.value);
        url.searchParams.delete('page');
        this.load(url, {skipValidation: true});
      } else if (this.form.contains(e.target) && e.target.name?.startsWith('filter.')) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.load(this.formURL()), e.target.type === 'number' ? 450 : 180);
      }
    }
    cancelFilters() {
      if (!this.draft) return;
      clearTimeout(this.timer);
      this.serial++;
      this.controller?.abort();
      this.querySelector('[data-filters-body]').innerHTML = this.savedFilters;
      this.querySelector('[data-apply]').textContent = this.savedApply;
      this.draft = false;
      if (this.panel.open) this.panel.close();
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
      this.setBusy(false);
      this.querySelectorAll('[data-error-message], [data-panel-error]').forEach(message => message.hidden = true);
      this.limitAllOptions();
      this.querySelector('[data-open-filters]').focus();
    }
    setBusy(busy) {
      this.querySelector('[data-products]').setAttribute('aria-busy', String(busy && !this.draft));
      this.querySelector('[data-apply]').disabled = busy;
    }
    async load(url, options = {}) {
      if (!options.skipValidation && options.history !== false && !this.form.reportValidity()) return;
      const inputs = [...this.form.querySelectorAll('input[type=number]')];
      if (!options.skipValidation && options.history !== false && inputs.length === 2 && inputs.every(input => input.value !== '') && Number(inputs[0].value) > Number(inputs[1].value)) {
        inputs[1].setCustomValidity(this.dataset.error);
        inputs[1].reportValidity();
        inputs[1].setCustomValidity('');
        return;
      }
      clearTimeout(this.timer);
      const requestId = ++this.serial;
      this.controller?.abort();
      this.controller = new AbortController();
      this.retryURL = url.href;
      this.retryOptions = options;
      this.querySelectorAll('[data-error-message], [data-panel-error]').forEach(message => message.hidden = true);
      this.setBusy(true);
      const renderURL = new URL(url.href);
      renderURL.searchParams.set('section_id', this.dataset.section);
      try {
        let html = this.cache.get(renderURL.href);
        if (!html) {
          const response = await fetch(renderURL.href, {signal: this.controller.signal, headers: {'X-Requested-With': 'XMLHttpRequest'}});
          if (!response.ok) throw new Error(String(response.status));
          html = await response.text();
          this.cache.set(renderURL.href, html);
          if (this.cache.size > 8) this.cache.delete(this.cache.keys().next().value);
        }
        if (requestId !== this.serial) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
        if (!parsed?.querySelector('[data-products]')) throw new Error('Invalid section');
        const state = [...this.querySelectorAll('[data-filter-group]')].map(group => ({key: group.dataset.filterGroup, open: group.open, query: group.querySelector('[data-option-search]')?.value || '', expanded: group.querySelector('[data-more-options]')?.getAttribute('aria-expanded'), buckets: [...group.querySelectorAll('[data-options-bucket]')].map(bucket => ({key: bucket.dataset.optionsBucket, open: bucket.open, beforeSearch: bucket.getAttribute('data-open-before-search')}))}));
        this.querySelector('[data-filters-body]').innerHTML = parsed.querySelector('[data-filters-body]').innerHTML;
        this.querySelector('[data-apply]').textContent = parsed.querySelector('[data-apply]').textContent;
        state.forEach(item => {
          const group = [...this.querySelectorAll('[data-filter-group]')].find(element => element.dataset.filterGroup === item.key);
          if (!group) return;
          group.open = item.open;
          const search = group.querySelector('[data-option-search]');
          if (search) search.value = item.query;
          if (item.expanded) group.querySelector('[data-more-options]')?.setAttribute('aria-expanded', item.expanded);
          item.buckets.forEach(saved => {
            const bucket = [...group.querySelectorAll('[data-options-bucket]')].find(element => element.dataset.optionsBucket === saved.key);
            if (!bucket) return;
            bucket.open = saved.open;
            if (saved.beforeSearch !== null) bucket.setAttribute('data-open-before-search', saved.beforeSearch);
          });
        });
        this.limitAllOptions();
        if (!this.draft || options.commitDraft) {
          this.querySelector('[data-products]').innerHTML = parsed.querySelector('[data-products]').innerHTML;
          this.querySelector('[data-selected]').innerHTML = parsed.querySelector('[data-selected]').innerHTML;
          this.querySelector('[data-count-label]').textContent = parsed.querySelector('[data-count-label]').textContent;
          this.querySelector('[data-active-count]').textContent = parsed.querySelector('[data-active-count]').textContent;
          this.querySelector('[data-sort-select]').value = parsed.dataset.sort;
          this.form.elements.sort_by.value = parsed.dataset.sort;
          this.querySelectorAll('[data-sort-choice]').forEach(input => input.checked = input.value === parsed.dataset.sort);
          this.dataset.count = parsed.dataset.count;
          if (options.history !== false && url.href !== location.href) history.pushState({saiyisCollection: true}, '', url.href);
          if (this.draft) {
            this.draft = false;
            this.panel.close();
            this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
            this.querySelector('[data-open-filters]').focus();
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError' && requestId === this.serial) {
          const message = this.querySelector(this.draft ? '[data-panel-error]' : '[data-error-message]');
          message.querySelector('span').textContent = this.dataset.error;
          message.hidden = false;
        }
      } finally {
        if (requestId === this.serial) this.setBusy(false);
      }
    }
  }
  customElements.define('saiyis-collection-browser', SaiyisCollectionBrowser);
})();

